import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/finance/public-funds`;

export const financePublicFundsAPI = {
  getAll: () => apiClient(`${BASE}/`),
  getById: (id) => apiClient(`${BASE}/entities/${id}`),
  create: (data) => apiClient(`${BASE}/`, { method: 'POST', body: JSON.stringify(data) }),
  update: (id, data) =>
    apiClient(`${BASE}/entities/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id) => apiClient(`${BASE}/entities/${id}`, { method: 'DELETE' }),
  bulkDelete: (ids) =>
    apiClient(`${BASE}/bulk-delete`, { method: 'POST', body: JSON.stringify({ ids }) }),
  bulkUpdate: (payload) =>
    apiClient(`${BASE}/bulk-update`, { method: 'POST', body: JSON.stringify(payload) }),
  bulkImport: (items) =>
    apiClient(`${BASE}/bulk-import`, { method: 'POST', body: JSON.stringify({ items }) }),

  getContacts: (parentId) => {
    const q = parentId ? `?parent_id=${encodeURIComponent(parentId)}` : '';
    return apiClient(`${BASE}/contacts/${q}`);
  },
  createContact: (data) =>
    apiClient(`${BASE}/contacts/`, { method: 'POST', body: JSON.stringify(data) }),
  updateContact: (id, data) =>
    apiClient(`${BASE}/contacts/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteContact: (id) => apiClient(`${BASE}/contacts/${id}`, { method: 'DELETE' }),
  bulkDeleteContacts: (ids) =>
    apiClient(`${BASE}/contacts/bulk-delete`, { method: 'POST', body: JSON.stringify({ ids }) }),
  bulkImportContacts: (contacts) =>
    apiClient(`${BASE}/contacts/bulk-import`, {
      method: 'POST',
      body: JSON.stringify({ contacts }),
    }),

  getTracking: () => apiClient(`${BASE}/activities/tracking`),
  getActivities: (entityId) => apiClient(`${BASE}/entities/${entityId}/activities`),
  createActivity: (entityId, data) =>
    apiClient(`${BASE}/entities/${entityId}/activities`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  updateActivity: (id, data) =>
    apiClient(`${BASE}/activities/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteActivity: (id) => apiClient(`${BASE}/activities/${id}`, { method: 'DELETE' }),
};

export default financePublicFundsAPI;
